import {RMDNotificationStore} from "@/store/types/RMDNotificationStore";

const rmdNotifications = new RMDNotificationStore();

export {rmdNotifications};
